The individual person that is contributing to the workflow process.
